/**
 * Open a new browser window with the given HTML and trigger the print dialog.
 * Shared by the staff production-checklist and delivery-route print flows.
 */
export const openPrintWindow = (html) => {
  const printWindow = window.open('', '_blank');
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();
  // Give styles time to render before printing; don't auto-close so the
  // user can reprint or review after the dialog closes.
  setTimeout(() => printWindow.print(), 500);
};
